import { ethers } from 'ethers';

export const isNumber = (obj) => {
  const reg = /^[0-9]+$/;
  if (reg.test(obj)) {
    return true;
  }
  return false;
}

export const isEmail = (obj) => {
  const reg = /^[A-Za-z0-9]+([_.][A-Za-z0-9]+)*@([A-Za-z0-9-]+\.)+[A-Za-z]{2,6}$/;
  if (reg.test(obj)) {
    return true;
  }
  return false;
}

export const mobileValidator = (value) => {
  if (!value) {
    return Promise.reject(new Error('require'));
  }

  if (value.length > 11 || !isNumber(value)) {
    return Promise.reject(new Error('>11  num'));
  }

  return Promise.resolve();
}

export const checkValidate = (formRef, checkArr) => {
  // checkArr = ['mobile', 'password'] 检查 手机号,密码... 是否都通过前端校验
  // formRef
  // hook: const [form] = Form.useForm();
  // class: formRef = React.createRef() this.form.current
  let passValidate;
  const fieldsError = formRef?.current?.getFieldsError(checkArr)
  let errors = [];
  fieldsError?.forEach((itemErrors, index) => {
    errors = errors.concat(itemErrors.errors)
  })
  if (errors.length > 0) {
    passValidate = false;
  } else {
    passValidate = true;
  }
  return passValidate;
}

export const isValidWeb3Address = (address) => {
  return ethers.utils.isAddress(address);
};
